"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var Header = function Header(_ref) {
  var leftComponent = _ref.leftComponent,
      rightComponent = _ref.rightComponent,
      centerComponent = _ref.centerComponent,
      maxWidth = _ref.maxWidth;
  return _react["default"].createElement(_style.Container, null, _react["default"].createElement(_style.Main, {
    maxWidth: maxWidth
  }, _react["default"].createElement(_style.Column, null, leftComponent), _react["default"].createElement(_style.Column, null, centerComponent), _react["default"].createElement(_style.Column, null, rightComponent)));
};

Header.propTypes = {
  leftComponent: _propTypes["default"].node,
  rightComponent: _propTypes["default"].node,
  centerComponent: _propTypes["default"].node,
  maxWidth: _propTypes["default"].string
};
Header.defaultProps = {
  leftComponent: null,
  rightComponent: null,
  centerComponent: null,
  maxWidth: '100%'
};
var _default = Header;
exports["default"] = _default;